import { render, staticRenderFns } from "./newBankInfo.vue?vue&type=template&id=ab4155a6&scoped=true"
import script from "./newBankInfo.vue?vue&type=script&lang=js"
export * from "./newBankInfo.vue?vue&type=script&lang=js"
import style0 from "./newBankInfo.vue?vue&type=style&index=0&id=ab4155a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4155a6",
  null
  
)

export default component.exports